
export default {
  /*
    *【base】   接口地址
    * rzUrl】  统一认证地址
  */

  // //正式 【https://volunteer.tjbwg.com/#/】
  base: 'https://volunteerbg.tjbwg.cn',
  rzUrl: 'https://ssobg.tjbwg.com',

  //华为云 【http://zyz.tiptimes.com/#/】
  // base: 'https://test2.tjbwg.com',
  // rzUrl: 'http://qtbrz.tiptimes.com/#/',

  // 汇星云测试
  // base: 'http://8.142.98.113:9012',
  // rzUrl: 'http://8.142.98.113:9013',

  //本地
  // base: 'http://192.168.1.120:8082',


}
